export default __webpack_public_path__ + "static/media/graduate-error.c977606b.png";